(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Lynk Crafts: square black Razorpay Magic Buy Now */
    function styleMagicButtons() {
      document.querySelectorAll('magic-checkout-btn[page-type="product"]').forEach(function (btn) {
        if (btn.getAttribute('border-radius') !== '0px') btn.setAttribute('border-radius', '0px');
        if (btn.getAttribute('bg-color') !== '#000000') btn.setAttribute('bg-color', '#000000');
        if (btn.getAttribute('width') !== '100%') btn.setAttribute('width', '100%');
      });
    }
    styleMagicButtons();
    new MutationObserver(styleMagicButtons).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
